module.exports = __webpack_public_path__ + "img/bill.3d3a5280.svg";